import { useEffect, useState } from "react";
import api from "services/api";
import config from "config";
import { getcodCidade } from "functions/gettabconfig";
import './style.css';
import Tabs from "components/tabs/tabs";
import Turismo from "components/turismo";

function LISTATURISMO() {
    const [ltipo0, setltipo0] = useState([]);
    const [ltipo1, setltipo1] = useState([]);
    const [ltipo2, setltipo2] = useState([]);
    const [ltipo3, setltipo3] = useState([]);
    const [ltipo4, setltipo4] = useState([]);

    useEffect(() => {
        // Busca Turismo para os tipos 0, 1, 2, 3, 4
        const fetchData = async (tipo, setTipo) => {
            try {
                const response = await api.get(`${config.TURISMO}?tipo=${tipo}&cod_cidade=${getcodCidade()}`);
                setTipo(response.data);
            } catch (error) {
                console.log(error);
            }
        };

        fetchData(0, setltipo0);
        fetchData(1, setltipo1);
        fetchData(2, setltipo2);
        fetchData(3, setltipo3);
        fetchData(4, setltipo4);
    }, []);

    const renderGrid = (list) => (
        <div className="turismo-grid">
            {list.map((b) => (
                <Turismo
                    key={`turismo-${b.id_turismo}`}
                    descricao={b.descricao}
                    banner={`${config.BASEIMG}${b.url_foto}`}
                    link={b.url_site}
                />
            ))}
        </div>
    );

    return (
        <div>
            <h1 className="section-title">
                <i className="fas fa-map-marked-alt" style={{marginRight: '12px'}}></i>
                Turismo
            </h1>
            <Tabs>
                <div label="Locais">
                    {renderGrid(ltipo0)}
                </div>
                <div label="Hoteis">
                    {renderGrid(ltipo1)}
                </div>
                <div label="Alimentação">
                    {renderGrid(ltipo2)}
                </div>
                <div label="Eventos">
                    {renderGrid(ltipo3)}
                </div>
                <div label="Uteis">
                    {renderGrid(ltipo4)}
                </div>
            </Tabs>

        </div>
    );
}

export default LISTATURISMO;